import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ExternalSettingsService } from 'src/app/common/services/external-settings/external-settings.service';
import { ResponsiveDesignService } from 'src/app/common/services/responsive-design/responsive-design.service';
import { UIUtilityService } from 'src/app/system/utility/ui-utility.service';
import { MeConfirmDialogService } from './me-confirm.service';

@Component({
    selector: 'app-me-confirm',
    templateUrl: './me-confirm.component.html',
    styleUrls: ['./me-confirm.component.less'],
    standalone: false
})
export class MeConfirmComponent implements OnInit {
  // Use in template
  DialogType: typeof DialogType = DialogType;
  UIUtilityService: any = UIUtilityService;

  externalSettings!: any;
  message! : string[];
  bulletMessage!: string[];
  messageStyle!: DialogMessageStyle;
  bulletStyle!: DialogBulletStyle;

  confirmButtonStyle: string = 'button-action-base';
  cancelButtonStyle: string = 'button-action-cancel';
  otherButtonStyle: string = 'button-action-cancel';

  iconStyle: string = 'm-5';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogConfig,
    public dialog: MatDialogRef<MeConfirmComponent, boolean | null>,
    private srvES: ExternalSettingsService,
    public srvConfirm : MeConfirmDialogService,
    protected srvRpDesign: ResponsiveDesignService) { 

    // Set the Confirm Button to WARN if Delete
    if (data.dialogType == DialogType.DELETE) this.confirmButtonStyle = 'button-action-warn';

    // Override the Style again if pass from parent
    if (data.confirmButtonStyle) this.confirmButtonStyle = data.confirmButtonStyle;
    if (data.cancelButtonStyle) this.cancelButtonStyle = data.cancelButtonStyle;
    if (data.otherButtonStyle) this.otherButtonStyle = data.otherButtonStyle;

    if (data.otherButtonText) {
      this.cancelButtonStyle += ' mobile-btn';
      this.confirmButtonStyle += ' mobile-btn';
      this.otherButtonStyle += ' mobile-btn';
    }

    // Update Display Message
    this.message = this.parseMessage(this.data.message);
    this.bulletMessage = this.parseMessage(this.data.bulletMessage);

    this.messageStyle = data.messageStyle ?? DialogMessageStyle.CENTER_ALIGN;
    this.bulletStyle = data.bulletStyle ?? DialogBulletStyle.DISC;

    // this.srvRpDesign.isMobile$.subscribe((isMobile)=>{
    //   if (!isMobile) {
    //     this.iconStyle = 'm-5';
    //   } else {
    //     this.iconStyle = 'm-3';
    //   }
    // })
  }

  ngOnInit(): void {
    this.srvES.externalSettings$.subscribe((settings) => {
      this.externalSettings = settings;
    });
  }

  other(event: any): void {
    this.srvConfirm.startProcessing();
    this.dialog.close(null);
  }

  cancel(event: any): void {
    this.srvConfirm.startProcessing();
    this.dialog.close(false);
  }
  confirm(event: any): void {
    this.srvConfirm.startProcessing();
    this.dialog.close(true);
  }

  private parseMessage(input: string[]|string|undefined): string[] {
    if (input == null || undefined) return [];
    return (typeof input === 'string') ? [input] : input;
  }
}

export interface ConfirmDialogConfig {
  dialogType?: DialogType
  title: string;
  message: string | string[];
  messageStyle?: DialogMessageStyle;
  bulletMessage?: string | string[];
  bulletStyle?: DialogBulletStyle;
  confirmButtonText?: string;
  cancelButtonText?: string;
  otherButtonText?: string;
  confirmButtonStyle?: string;
  cancelButtonStyle?: string;
  otherButtonStyle?: string;
}

export enum DialogType {
  INFO = "INFO", 
  NORMAL = "NORMAL",
  DELETE = "DELETE",
  CANCEL = "CANCEL",
  REJECT = "REJECT",
  CONFIRM = "CONFIRM",
  IMAGE = "IMAGE"
}

export enum DialogMessageStyle {
  LEFT_ALIGN = "text-left",
  CENTER_ALIGN = "text-center",
  RIGHT_ALIGN = "text-right"
}

export enum DialogBulletStyle {
  DISC = "list-style-disc",
  NUMBER = "list-style-decimal",
  NONE = "list-style-none "
}